import {LastReplacementDatePicker} from '../components/LastReplacementDatePicker';
import {LastReplacementMileageInput} from '../components/LastReplacementMileageInput';
import {NextReplacementDatePicker} from '../components/NextReplacementDatePicker';
import {NextReplacementMileageInput} from '../components/NextReplacementMileageInput';
import {ReplacementAfterMileageInput} from '../components/ReplacementAfterMileageInput';
import {ReplacementAfterMonthsInput} from '../components/ReplacementAfterMonthsInput';

export function FourByFourOilDistributorReplacementGroup() {
  return (
    <>
      <LastReplacementDatePicker name="fourByFourOilDistributor" />
      <LastReplacementMileageInput name="fourByFourOilDistributor" />
      <NextReplacementDatePicker name="fourByFourOilDistributor" />
      <NextReplacementMileageInput name="fourByFourOilDistributor" />
      <ReplacementAfterMonthsInput name="fourByFourOilDistributor" />
      <ReplacementAfterMileageInput name="fourByFourOilDistributor" />
    </>
  );
}
